export default __webpack_public_path__ + "static/media/token_thin.51a20355.png";